<header class="flex header p-2">
  <h2>{{ 'Production_Card_Move_To_Batch_ReturnRollsToGreige' | translateWF: 'Return Rolls to Greige' }}</h2>
</header>

<section class="content">
  <p class="mb-3 text-sm text-gray-600">
    {{ 'Production_Card_Move_To_Batch_SelectRollsToReturn' | translateWF: 'Select rolls to return to Greige. Only rolls that are NOT in a bundle can be returned.' }}
  </p>

  <!-- Filter by roll number -->
  <div class="mb-3">
    <label for="returnRollFilter" class="block text-sm font-medium mb-2">
      {{ 'Production_Card_Move_To_Batch_FilterByRollNumber' | translateWF: 'Filter by Roll Number' }}
    </label>
    <p-autoComplete
      id="returnRollFilter"
      [ngModel]="returnRollFilter()"
      (ngModelChange)="returnRollFilter.set($event)"
      [dropdown]="false"
      [suggestions]="[]"
      placeholder="{{ 'Production_Card_Move_To_Batch_SearchRollNumber' | translateWF: 'Search roll number...' }}"
      styleClass="w-full"
    />
  </div>

  <p-table
    [value]="filteredRollsAvailableForReturn()"
    [loading]="isLoading() > 0"
    [selection]="selectedRollsToReturn()"
    (selectionChange)="selectedRollsToReturn.set($event)"
    dataKey="number"
    [scrollable]="true"
    scrollHeight="400px"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem">
          <p-tableHeaderCheckbox />
        </th>
        <th>{{ 'Production_Card_Move_To_Batch_RollNumber' | translateWF: 'Roll Number' }}</th>
        <th>{{ 'Production_Card_Move_To_Batch_FabricCode' | translateWF: 'Fabric Code' }}</th>
        <th>{{ 'Production_Card_Move_To_Batch_WeightLb' | translateWF: 'Weight (lb)' }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-roll>
      <tr>
        <td>
          <p-tableCheckbox [value]="roll" />
        </td>
        <td>{{ roll.number }}</td>
        <td>{{ roll.expectedFabricCode }}</td>
        <td>{{ roll.stationTimeStamps?.[roll.stationTimeStamps.length - 1]?.weightInLbs | number: '1.0-2' }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4" class="text-center py-4">
          {{ 'Production_Card_Move_To_Batch_NoRollsAvailableForReturn' | translateWF: 'No rolls available for return' }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>

<footer>
  <p-button [label]="'Common_Cancel' | translateWF: 'Cancel'" variant="outlined" (onClick)="onCancel()" [disabled]="isLoading() > 0" />
  <p-button
    [label]="'Production_Card_Move_To_Batch_ReturnSelected' | translateWF: 'Return Selected'"
    icon="pi pi-undo"
    severity="warn"
    [disabled]="selectedRollsToReturn().length === 0 || isLoading() > 0"
    [loading]="isLoading() > 0"
    (onClick)="onReturnSelected()"
  />
</footer>
